<template>
    <div class="charts">
        <div class="chart-cont" ref="barMian"></div>
    </div>
</template>

<script>
import * as methods from './method.js'
export default {
    name: 'template.scope124',
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            timer: null,
            defaultdata: [
                { value1: '西埔所', value2: '20', value3: '正常营业', value4: '户' },
                { value1: '西埔所', value2: '10', value3: '暂停营业', value4: '户' },
                { value1: '西埔所', value2: '10', value3: '已经注销', value4: '户' },
                { value1: '铜陵所', value2: '30', value3: '正常营业', value4: '户' },
                { value1: '铜陵所', value2: '20', value3: '暂停营业', value4: '户' },
                { value1: '铜陵所', value2: '10', value3: '已经注销', value4: '户' },
                { value1: '陈城所', value2: '10', value3: '正常营业', value4: '户' },
                { value1: '陈城所', value2: '20', value3: '暂停营业', value4: '户' },
                { value1: '陈城所', value2: '10', value3: '已经注销', value4: '户' },
                { value1: '杏陈所', value2: '30', value3: '正常营业', value4: '户' },
                { value1: '杏陈所', value2: '20', value3: '暂停营业', value4: '户' },
                { value1: '杏陈所', value2: '20', value3: '已经注销', value4: '户' },
                { value1: '康美所', value2: '10', value3: '正常营业', value4: '户' },
                { value1: '康美所', value2: '30', value3: '暂停营业', value4: '户' },
                { value1: '康美所', value2: '20', value3: '已经注销', value4: '户' },
                { value1: '池园所', value2: '30', value3: '正常营业', value4: '户' },
                { value1: '池园所', value2: '10', value3: '暂停营业', value4: '户' },
                { value1: '池园所', value2: '10', value3: '已经注销', value4: '户' },
                { value1: '樟塘所', value2: '20', value3: '正常营业', value4: '户' },
                { value1: '樟塘所', value2: '10', value3: '暂停营业', value4: '户' },
                { value1: '樟塘所', value2: '30', value3: '已经注销', value4: '户' },
                { value1: '前楼所', value2: '30', value3: '正常营业', value4: '户' },
                { value1: '前楼所', value2: '10', value3: '暂停营业', value4: '户' },
                { value1: '前楼所', value2: '10', value3: '已经注销', value4: '户' },
            ],
            valueMap: [
                { name: '名称', key: "value1" },
                { name: '数值', key: "value2" },
                { name: '图例', key: 'value3' },
                { name: '单位', key: 'value4' }
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            config: {
            },
        }
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
            }
        },
        jsondata(n) {
            this.exceldata = n
        },
        defaultdata(n) {
            this.DrawEcharts()
        }
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null
    },
    methods: {
        ...methods,
        DrawEcharts() {
            clearInterval(this.timer);
            this.timer = null;
            var echarts = require("echarts");
            var TmyChart = echarts.init(this.$refs.barMian);
            let data1 = [];
            let data2 = [];
            let legend = [];
            let colors = ['#0979F5', '#57E8CB', '#00D9FF', '#A6E6FF']
            let unit = this.defaultdata[0].value4
            let xdata = [...new Set(this.defaultdata.map((item) => item.value1))]
            let legends = [...new Set(this.defaultdata.map((item) => item.value3))]
            legends.forEach((item, i) => {
                let rights = (55 - i * 20) + '%'
                let vitem = {
                    show: true,
                    top: "2%",
                    right: rights,
                    itemHeight: 12, //图例的高度  文字左边那个
                    itemWidth: 10,
                    icon: "rect",
                    textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
                    data: [item],
                }
                legend.push(vitem)
            })
            let vdata = legends.map(item => {
                let vitem = this.defaultdata.filter(del => del.value3 == item)
                let xitem = xdata.map(del => {
                    return {
                        name: del,
                        value: vitem.find(arr => arr.value1 == del).value2
                    }
                })
                let yitem = {
                    name: item,
                    list: xitem
                }
                return yitem
            })
            let serie = vdata.map((item, i) => {
                let options = {
                    name: item.name,
                    type: "bar",
                    stack: "total",
                    barWidth: 15,
                    barGap: "40%",
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(
                                0,
                                0,
                                1,
                                1,
                                [
                                    {
                                        offset: 1,
                                        color: 'rgba(0,0,0,.6)', // 0% 处的颜色
                                    },
                                    {
                                        offset: 0.5,
                                        color: colors[i], // 100% 处的颜色
                                    },
                                    {
                                        offset: 0,
                                        color: colors[i], // 100% 处的颜色
                                    },
                                ],
                                false
                            ),
                        },
                    },
                    data: item.list,
                }
                return options
            })
            var Toption = {
                // title: [
                //     {
                //         text: unit,
                //         top: "0",
                //         left: "0",
                //         textStyle: {
                //             color: "#979AA0",
                //             fontSize: 12,
                //         },
                //     },
                // ],
                tooltip: {
                    // trigger: 'axis'
                },
                legend: [...legend],
                grid: {
                    left: "5px",
                    right: "10px",
                    bottom: "10px",
                    top: "30px",
                    containLabel: true,
                },
                yAxis: {
                    type: "value",
                    splitNumber: 4,
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                            color: "rgba(231,241,251,.2)",
                        },
                    },
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
                        },
                    },
                },
                xAxis: {
                    type: "category",
                    z: 10,
                    data: xdata,
                    axisLabel: {
                        interval: 0,
                        width: 54,
                        overflow: "truncate", //文字超出宽度截断，默认为...
                        // overflow: 'break', //文字超出宽度截断 换行
                        textStyle: {
                            color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
                            fontSize: "14",
                            lineHeight: 16,
                        },
                        rotate: 15
                        // formatter: function (value) {
                        // 		return value.length > 6 ? value.slice(0, 5) + '...' : value;
                        // }
                    },
                    axisLine: {
                        lineStyle: {
                            // X 轴颜色配置
                            color: "#4792e9",
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                },
                series: [...serie],
            };
            Toption && TmyChart.setOption(Toption);
            this.timer = setInterval(() => {
                if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
                TmyChart.clear();
                Toption && TmyChart.setOption(Toption);
            }, 5000);
        },
    },
    created() {

    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata
        }
        this.setData()
        this.DrawEcharts(); //需要刷新的数据
    },

}
</script>

<style lang="scss">
.charts {
    width: 435px;
    height: 240px;
    padding: 10px 0;
    position: relative;

    .chart-cont {
        width: 100%;
        height: 100%;
    }
}
</style>